var EditableLink={Preview:{accessibilityLabel:"Visit the selected resource"},Edit:{content:"Edit",accessibilityLabel:"Edit the current resource"},Remove:{accessibilityLabel:"Remove the current resource"}};var _en = {EditableLink:EditableLink};

export { EditableLink, _en as default };
